import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { ACTION_ADD_POSTBACK_SETTINGS } from '../actionTypes';


export const actionAddPostbackSettings = postbackSettings => ({
  type: ACTION_ADD_POSTBACK_SETTINGS,
  payload: { postbackSettings },
});
